export default __webpack_public_path__ + "media/raduVid.a62dae4b.mp4";